export const environment = {
    production: false,
    buildNo:202609021847,
    ver:'0.0.1',
    apiUrl:'https://uat.crm.mojosoft.co.in/ws',
    userId: 'crm',
    password: 'stpierresCRM123#@!uat',
    appKey: "e568458e9121478125d076b344e26c9e",
    crmSingupURL:'https://uat.welcome.stpierres.mojosoft.co.in/register'
  };
  